/* eslint-disable camelcase */
import { useEffect, useMemo, useState, useReducer } from 'react';
import { useVisitorData } from '@fingerprintjs/fingerprintjs-pro-react';
import { isIOS } from 'react-device-detect';
import { useCookies } from 'react-cookie';
import Api from '~/api';
import { verifyViewer } from '~/api/NewViewer';
import { FINGERPRINT_COOKIE_LIFESPAN } from '~/constants/general';
export function useFingerPrintApp(data, verified, token) {
    const [state, dispatch] = useReducer((prevState, action) => {
        switch (action.type) {
            case 'VERIFIED':
                console.log('verified dispatch');
                return {
                    ...prevState,
                    verified: true,
                };
            case 'NOT_VERIFIED':
                console.log('not verified dispatch');
                return {
                    ...prevState,
                    verified: false,
                };
        }
    }, {
        verified: verified,
    });
    const fingerPrintContext = useMemo(() => ({
        fingerprint: data?.visitorId,
        country: data?.ipLocation?.country?.code,
        postalCode: data?.ipLocation?.postalCode,
        verifyUser: () => {
            dispatch({ type: 'VERIFIED' });
        },
    }), [data?.visitorId]);
    useEffect(() => {
        if (verified) {
            console.log('dispatching', verified);
            dispatch({ type: 'VERIFIED' });
        }
    }, [verified]);
    const openFormModal = !verified &&
        !state.verified &&
        token === undefined;
    return { fingerPrintContext, openFormModal };
}
export function useNewApp(token, eventId, mainCameraId) {
    const [cookies, setCookie] = useCookies(['OneroomFingerPrint']);
    const { isLoading, error, data } = useVisitorData({ extendedResult: true });
    const [verified, setVerified] = useState(false);
    const [verifying, setVerifying] = useState(true);
    useEffect(() => {
        const stopAnalytics = () => {
            Api.Analytics.stop(mainCameraId, mainCameraId);
        };
        const eventName = isIOS ? 'pagehide' : 'unload';
        window.addEventListener(eventName, stopAnalytics);
        return () => {
            stopAnalytics();
        };
    }, []);
    useEffect(() => {
        const verifyFingerprint = async () => {
            if (data) {
                const verifyResponse = await verifyViewer(data.visitorId, eventId);
                setCookie('OneroomFingerPrint', data, { maxAge: FINGERPRINT_COOKIE_LIFESPAN });
                if (verifyResponse) {
                    setVerifying(false);
                    setVerified(true);
                }
                else {
                    setVerifying(false);
                    setVerified(false);
                }
            }
        };
        const startAnalytics = () => {
            Api.Analytics.setPostData({
                ip4: data?.ip,
                uuid: data?.visitorId,
                fingerprint_id: data?.visitorId,
                admin_user: token !== undefined ? 1 : 0,
                country_name: data?.ipLocation?.country?.name,
                code: data?.ipLocation?.country?.code,
                city: data?.ipLocation?.city?.name,
                postcode: data?.ipLocation?.postalCode,
                lat: data?.ipLocation?.latitude,
                lon: data?.ipLocation?.longitude,
            });
            Api.Analytics.setConfig();
            Api.Analytics.init(mainCameraId, mainCameraId);
        };
        if (!isLoading && data?.visitorId) {
            verifyFingerprint();
            startAnalytics();
        }
    }, [isLoading, cookies, data?.visitorFound, data?.visitorId]);
    return { isLoading, token, error, verified, verifying, data };
}
export function useNewAppWithCookie(eventId, mainCameraId, data) {
    const [cookies] = useCookies(['OneroomAdminAPIToken']);
    const [verified, setVerified] = useState(false);
    const [verifying, setVerifying] = useState(true);
    useEffect(() => {
        const stopAnalytics = () => {
            Api.Analytics.stop(mainCameraId, mainCameraId);
        };
        const eventName = isIOS ? 'pagehide' : 'unload';
        window.addEventListener(eventName, stopAnalytics);
        return () => {
            stopAnalytics();
        };
    }, []);
    useEffect(() => {
        const verifyFingerprint = async () => {
            if (data) {
                const verifyResponse = await verifyViewer(data.visitorId, eventId);
                if (verifyResponse) {
                    setVerifying(false);
                    setVerified(true);
                }
                else {
                    setVerifying(false);
                    setVerified(false);
                }
            }
        };
        const startAnalytics = () => {
            Api.Analytics.setPostData({
                ip4: data.ip,
                uuid: data.visitorId,
                fingerprint_id: data?.visitorId,
                admin_user: cookies?.OneroomAdminAPIToken !== undefined ? 1 : 0,
                country_name: data.ipLocation?.country?.name,
                code: data.ipLocation?.country?.code,
                city: data.ipLocation?.city?.name,
                postcode: data.ipLocation?.postalCode,
                lat: data.ipLocation?.latitude,
                lon: data.ipLocation?.longitude,
            });
            Api.Analytics.setConfig();
            Api.Analytics.init(mainCameraId, mainCameraId);
        };
        if (data.visitorId) {
            verifyFingerprint();
            startAnalytics();
        }
    }, [cookies?.OneroomAdminAPIToken, data.visitorFound, data.visitorId]);
    return {
        token: cookies.OneroomAdminAPIToken,
        verified,
        verifying,
    };
}
